import { createStyles, Theme } from '@material-ui/core/styles'

export default (theme: Theme) =>
	createStyles({
		locationsRoot: {
			padding: '2px 0px',
			display: 'flex',
			alignItems: 'flex-start',
			flexDirection: 'column',
		},
		selectedLoc: {
			display: 'flex',
			alignItems: 'flex-start',
			flexDirection: 'row',
		},
		chip: {
			margin: 2,
			'&:hover, &:focus': {
				backgroundColor: '#e1e1f4 !important',
				color: '#1B1A7C',
			}
		}
	})